import {
  InventorizationIncorrectStatus,
  InventorizationStatus,
} from '../../../entities/InventorizationStatus';
import type { Place, StorageEntityInfo } from '../types/warehouse.types';

export interface ScanStatusResult {
  status: InventorizationStatus;
  incorrectStatus?: InventorizationIncorrectStatus;
}


export const isCodeCeelNumber = (entity:StorageEntityInfo, code: string): boolean => (entity.ceel_number === code);
export const isCodeSSCC = (entity:StorageEntityInfo, code: string): boolean => (entity.pallet_sscc === code);
/**
 * Status for a pallet code scanned at the selected place: it matches one of the
 * pallets the system expects there, or the place holds something else.
 */
export const getStatusForPalletScan = (
  code: string,
  isPlaceEmpty: boolean,
  storageEntities: StorageEntityInfo[]
): ScanStatusResult => {
  const isMatched = storageEntities.some(
    (entity) => isCodeSSCC(entity, code) || isCodeCeelNumber(entity, code)
  );

  return isMatched
    ? { status: InventorizationStatus.correct }
    : {
        status: InventorizationStatus.incorrect,
        incorrectStatus: isPlaceEmpty ? InventorizationIncorrectStatus.place_empty : InventorizationIncorrectStatus.wrong_pallet,
      };
};

export const getStatusForPlaceScan = (isPlaceEmpty: boolean): ScanStatusResult => ( isPlaceEmpty ? {
  status: InventorizationStatus.correct,
} : {  
  status: InventorizationStatus.incorrect,
  incorrectStatus: InventorizationIncorrectStatus.pallet_missing,
});

const normalize = (value?: string | null): string => (value ?? '').trim().toLowerCase();

/**
 * Resolves a scanned or typed code to a place. Labels in the warehouse carry the
 * current address, but older ones still carry the rack or the pre-migration address,
 * so all identifiers a place is known by are accepted.
 */
export const findPlaceByCode = (places: Place[], code: string): Place | null => {
  const wanted = normalize(code);
  if (!wanted) return null;

  return places.find((place) => (
    normalize(place.place_id) === wanted ||
    normalize(place.address) === wanted ||
    normalize(place.rack_address) === wanted ||
    normalize(place.old_address) === wanted
  )) ?? null;
};
